var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33763 24C9.20557 23.825 9.10265 23.716 9.0307 23.5896C7.84486 21.4998 6.14535 19.8489 4.48318 18.1623C3.21537 16.876 2.03955 15.5192 1.17613 13.9114C-2.07262 7.85567 1.87561 1.45089 7.32481 0.21776C12.3587 -0.921926 17.5756 2.53653 18.5092 7.67977C19.0502 10.6618 18.1613 13.2664 16.3953 15.5962C15.5264 16.7432 14.5154 17.7867 13.5163 18.8265C12.1228 20.2777 10.7175 21.7124 9.71014 23.4805C9.61451 23.6454 9.48791 23.7911 9.33763 24ZM13.3378 9.49924C13.3378 7.29041 11.5463 5.47919 9.35312 5.46911C7.13719 5.45903 5.32383 7.273 5.32383 9.49924C5.32383 11.7072 7.11624 13.5202 9.30849 13.5294C11.5235 13.5394 13.3378 11.7246 13.3378 9.49924Z",
    fill: "#35B369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pinLocation.70f76aa7447093288e06c5bdf986e167.svg";
export { ForwardRef as ReactComponent };